import styled from "styled-components";

function CartItem({id, thumbnailImg, title, classData, optionList, totalAmount, onCartItemClickHandler, checked}){
    const renderOption = () => {
        if(optionList && optionList.length){
            return optionList.map((item, index) => {
                return <Li key={item.id}>{`${item.name} - ${item.amount.toLocaleString()}원`}</Li>
            })
        }
        return null;
    }

    return(
       <Container>
        <CheckBox type="checkbox" onChange={() => onCartItemClickHandler(id, totalAmount)} defaultChecked={checked}/>
            <ContentWrap>
                <ThumbnailImg src={thumbnailImg} alt="thumbnail_img"/>
                <Content>
                    <Title>{title}</Title>
                    <Ul>
                        <Li>{`${classData.name} - ${classData.amount.toLocaleString()}원`}</Li>
                        {renderOption()}
                        <Li>{`TOTAL: ${totalAmount.toLocaleString()}원`}</Li>
                    </Ul>
                </Content>
            </ContentWrap>
       </Container>
    )
}

const Container = styled.div`
    display: flex;
    align-items: center;
    gap: 20px;
    
`

const CheckBox = styled.input`
    width: 20px;
    height: 20px;
`

const ContentWrap = styled.div`
    display: flex;
    gap: 20px;
    align-items: center;
    @media (max-width: 600px) {
       flex-direction: column;
       align-items: center;
    }
`

const ThumbnailImg = styled.img`
    width: 200px;
    height: 150px;
`

const Content = styled.div`
    display: flex;
    flex-direction: column;
    padding-top: 10px;
    padding-bottom: 10px;
    height: 100%;
`

const Title = styled.div`
    font-size: 18px;
    font-weight: 600;
`

const Ul = styled.ul`

`
const Li = styled.li`
    font-size: 16px;
`
export default CartItem;